import { render, staticRenderFns } from "./ReviewBox.vue?vue&type=template&id=ecf32434&scoped=true"
import script from "./ReviewBox.vue?vue&type=script&lang=ts"
export * from "./ReviewBox.vue?vue&type=script&lang=ts"
import style0 from "./ReviewBox.vue?vue&type=style&index=0&id=ecf32434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf32434",
  null
  
)

export default component.exports